import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckIcon from '@mui/icons-material/Check';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import { Box, styled } from '@mui/material';

const chipStyles = {
  width: '28px',
  height: '16px',
  borderRadius: '16px',
  color: 'rgba(97, 108, 121, 1)',
  backgroundColor: 'rgba(225, 228, 231, 1)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-around'
};

const iconStyles = {
  fontSize: '12px'
};

export const DefaultColorChip = styled((props: any) => (
  <Box sx={{ ...chipStyles }}>
    <AccessTimeIcon sx={{ ...iconStyles }} />
  </Box>
))(() => ({}));

export const ProgressColorChip = styled((props: any) => (
  <Box sx={{ ...chipStyles, color: 'rgba(2, 89, 171, 1)', backgroundColor: 'rgba(206, 232, 255, 1)' }}>
    <AccessTimeIcon sx={{ ...iconStyles }} />
  </Box>
))(() => ({}));

export const SuccessColorChip = styled((props: any) => (
  <Box sx={{ ...chipStyles, color: 'rgba(0, 94, 5, 1)', backgroundColor: 'rgba(216, 248, 217, 1)' }}>
    <CheckIcon sx={{ ...iconStyles }} />
  </Box>
))(() => ({}));

export const WarningColorChip = styled((props: any) => (
  <Box sx={{ ...chipStyles, color: 'rgba(107, 73, 4, 1)', backgroundColor: 'rgba(255, 240, 202, 1)' }}>
    <ReportProblemOutlinedIcon sx={{ ...iconStyles }} />
  </Box>
))(() => ({}));

export const ErrorColorChip = styled((props: any) => (
  <Box sx={{ ...chipStyles, color: 'rgba(98, 27, 22, 1)', backgroundColor: 'rgba(251, 240, 240, 1)' }}>
    <ErrorOutlineIcon sx={{ ...iconStyles }} />
  </Box>
))(() => ({}));
